import GridSplash from './grid-splash';

export default GridSplash;